import { Timestamp } from "firebase/firestore";
import { BaseFirestore } from "./Firestore";
import { EmployeeEmailStatus } from "./EmailDeliveryLog";

export const EmployeeRole = [
  "admin",
  "office",
  "technician",
  "viewOnly",
] as const;
export type EmployeeRole = (typeof EmployeeRole)[number];

export const EmployeeJobTitle = {
  serviceAdvisor: "serviceAdvisor",
  technician: "technician",
  other: "other",
  SERVICE_ADVISOR: "serviceAdvisor",
  TECHNICIAN: "technician",
  OTHER: "other",
} as const;
export type EmployeeJobTitle =
  (typeof EmployeeJobTitle)[keyof typeof EmployeeJobTitle];

export type Employee = BaseFirestore & {
  schemaVersion: 2;
  disabled?: boolean;
  email: string;
  shopHeroRole?: EmployeeRole | null;
  shopHeroAuthUid?: string;
  firstName: string;
  lastName: string;
  id: string;
  hideInShopHero?: boolean;
  active?: boolean;
  sourceLastUpdated: Date | Timestamp;
  color?: string;
  shopHeroJobTitle?: EmployeeJobTitle | null;
  integrationRole?: string | null; // Role from the integration source, e.g. "technician", "serviceAdvisor", etc.
  latestActivationEmailStatus?: EmployeeEmailStatus;
  /**
   * The `logId` of the most recently *started* activation-email send (set by
   * `emailDeliveryLogRepository.create`) — distinct from
   * `latestActivationEmailStatus.logId`, which is the log of the most
   * recently *applied webhook event*. Lets `applyDeliveryEvent` tell whether
   * an incoming event belongs to the current send or a superseded one (e.g.
   * the attempt before a Resend), so a late event for an old logId can't
   * clobber a newer attempt's already-recorded status.
   */
  currentActivationLogId?: string | null;
};

// Type for creating a new employee
export type CreateEmployeeDto = Pick<
  Employee,
  | "firstName"
  | "lastName"
  | "email"
  | "sourceLastUpdated"
  | "color"
  | "shopHeroJobTitle"
> & { schemaVersion: number };
